
const changeHasBar= (state,payload)=>{
    state.hasBar = payload.hasBar
}
const changeBarFixed= (state,payload)=>{
    state.barFixed = payload.barFixed
}
const windowInnerHeight= (state,payload)=>{
    state.windowInnerHeight = payload.windowInnerHeight
}
const changeRadio= (state,payload)=>{
    state.radio = payload.radio
}
const storeChooseGifts= (state,payload)=>{
    state.chooseGifts = payload.chooseGifts
}
const storeCode= (state,payload)=>{
    state.code = payload.code
}
const storeOpenid= (state,payload)=>{
    state.openid = payload.openid
}



let mutations = {
    changeHasBar,
    changeBarFixed,
    windowInnerHeight,
    changeRadio,
    storeChooseGifts,
    storeCode,
    storeOpenid
}
export default mutations